module.exports = __webpack_public_path__ + "img/1517678588.a03e5b89.jpg";